import { IUser } from '@common/types/user';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store/store';

interface UserState {
    user: IUser | null;
}

const initialState: UserState = {
    /**
     * This variable should only be used after you're sure the user is logged in.
     * Otherwise, for syncronous check, use the useAuth hook
     */
    user: null,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action: PayloadAction<IUser | null>) => {
            state.user = action.payload;
        },
    },
});

const selectUser = (state: RootState) => state.user.user;

export const { setUser } = userSlice.actions;
export { selectUser };
export default userSlice.reducer;
